import { AuthCoreService } from '../../core/auth-core/auth-core.service';

export const deactivateLoginGuard = () => {
  //   const authService = inject(AuthService);
  return AuthCoreService.isLoggedIn;
};
